import axios from "axios";

export const defaultAgeSettings = {
  minAge: 18,
  maxAge: 70,
  defaultMinAge: 18,
  defaultMaxAge: 40,
};

const toAge = (value, fallback) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const normalizeAgeSettings = (data = {}) => {
  let minAge = toAge(data.min_age, defaultAgeSettings.minAge);
  let maxAge = Math.min(toAge(data.max_age, defaultAgeSettings.maxAge), 70);
  let defaultMinAge = toAge(data.default_min_age, defaultAgeSettings.defaultMinAge);
  let defaultMaxAge = toAge(data.default_max_age, defaultAgeSettings.defaultMaxAge);

  if (minAge > maxAge) {
    [minAge, maxAge] = [maxAge, minAge];
  }

  defaultMinAge = Math.min(Math.max(defaultMinAge, minAge), maxAge);
  defaultMaxAge = Math.min(Math.max(defaultMaxAge, minAge), maxAge);

  if (defaultMinAge > defaultMaxAge) {
    [defaultMinAge, defaultMaxAge] = [defaultMaxAge, defaultMinAge];
  }

  return { minAge, maxAge, defaultMinAge, defaultMaxAge };
};

export const fetchAgeSettings = async (basUrl) => {
  try {
    const res = await axios.get(`${basUrl}age_settings`);
    if (res.data?.Result === "true") {
      return normalizeAgeSettings(res.data);
    }
  } catch (err) {
    return defaultAgeSettings;
  }
  return defaultAgeSettings;
};
